import { Lightbulb, BookOpen, Users, Heart, Target, Home } from 'lucide-react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  return (
    <div className="wcu-page-wrapper">
     
       {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>WHY CHOOSE US</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Why Choose Us</li>
          </ul>
        </div>
      </section>

      {/* Content */}
      <div className="wcu-main-content">
        <div className="wcu-inner-wrap">
          <p className="wcu-opening-text">
            We combine traditional values with modern education to create an unparalleled learning experience.
          </p>

          <div className="wcu-features-list">
            <div className="wcu-item-block">
              <div className="wcu-symbol-area">
                <div className="wcu-circle-bg">
                  <Lightbulb className="wcu-graphic" size={32} />
                </div>
              </div>
              <div className="wcu-details-area">
                <h3 className="wcu-item-title">Smart Classrooms</h3>
                <p className="wcu-item-info">
                  Our state-of-the-art smart classrooms are equipped with interactive boards, projectors, and audio-visual aids 
                  that make learning engaging and effective. Students can visualize complex concepts and participate in 
                  interactive lessons.
                </p>
              </div>
            </div>

            <div className="wcu-item-block">
              <div className="wcu-symbol-area">
                <div className="wcu-circle-bg">
                  <BookOpen className="wcu-graphic" size={32} />
                </div>
              </div>
              <div className="wcu-details-area">
                <h3 className="wcu-item-title">Digital Learning Tools</h3>
                <p className="wcu-item-info">
                  We leverage the latest educational technology including tablets, learning apps, and online resources 
                  to supplement traditional teaching methods. This prepares students for the digital age while maintaining 
                  strong fundamentals.
                </p>
              </div>
            </div>

            <div className="wcu-item-block">
              <div className="wcu-symbol-area">
                <div className="wcu-circle-bg">
                  <Users className="wcu-graphic" size={32} />
                </div>
              </div>
              <div className="wcu-details-area">
                <h3 className="wcu-item-title">Skilled Teachers</h3>
                <p className="wcu-item-info">
                  Our faculty members are not just qualified educators but passionate mentors who undergo regular training 
                  to stay updated with the latest teaching methodologies. They understand each child's unique learning style 
                  and adapt accordingly.
                </p>
              </div>
            </div>

            <div className="wcu-item-block">
              <div className="wcu-symbol-area">
                <div className="wcu-circle-bg">
                  <Heart className="wcu-graphic" size={32} />
                </div>
              </div>
              <div className="wcu-details-area">
                <h3 className="wcu-item-title">Value-Based Environment</h3>
                <p className="wcu-item-info">
                  We believe education goes beyond academics. Our curriculum integrates moral values, ethics, and life skills 
                  that help students develop into compassionate and responsible individuals who contribute positively to society.
                </p>
              </div>
            </div>

            <div className="wcu-item-block">
              <div className="wcu-symbol-area">
                <div className="wcu-circle-bg">
                  <Target className="wcu-graphic" size={32} />
                </div>
              </div>
              <div className="wcu-details-area">
                <h3 className="wcu-item-title">Nurturing Real Potential</h3>
                <p className="wcu-item-info">
                  Every child has unique talents and abilities. Our approach focuses on identifying and nurturing these 
                  individual strengths through personalized attention, diverse activities, and continuous encouragement, 
                  helping each student discover and achieve their true potential.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;